// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";

export interface AddressValidationApiParameter extends ApiParameter {
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
}

export interface AddressValidationResult {
    addressResultDto?: {
        address1: string;
        address2: string;
        address3: string;
        address4: string;
        city: string;
        state: string | StateModel;
        postalCode: string;
        county: string;
        country: string | CountryModel;
        matchScore: string;
        mailabilityScore: number;
        isMatch: boolean;
        meetsMinimumMailabilityScore?: boolean;
    };
    errorMessage?: string;
    errorCode?: number;
}

const addressValidationServiceUrl = "/api/psc/address-validation";

export function validateAddress(parameter: AddressValidationApiParameter) {
    return post<AddressValidationApiParameter, AddressValidationResult>(addressValidationServiceUrl, parameter);
}
